import cn from "classnames";
import React from "react";

export interface CardContentProps extends React.HTMLProps<HTMLDivElement> {}

export const CardContent = React.forwardRef<HTMLDivElement, CardContentProps>(({ className, ...props }, ref) => {
  return <div ref={ref} className={cn("card__content", className)} {...props} />;
});
